import React, {useState} from "react";
import signInBanner from "../../../assets/images/icons/ic-signin.svg";
import {useLocation, useNavigate} from "react-router-dom";
import {RouteHelper} from "../../../route/RouteHelper";
import {FormControl} from "@mui/material";
import {css} from "@emotion/css";
import {LoginService} from "../../../connection-services/login/LoginService";
import {LoadingHelper} from "../../../util/LoadingHelper";
import {useLoadingDispatcher} from "../../../context/LoadingContext";
import {
    RaikoButtonPrimary,
    RaikoInputSubmitCode,
    RaikoMaterialOutlinedInput, RaikoPasswordOutlined,
    showErrorMessage,
    showSuccessMessage,
    showWarningMessage
} from "@moeindal/base-raiko-panel-components";
import {Helmet} from "react-helmet";
import {detectServerErrorMessage} from "../../../util/detectServerErrorMessage";

const SignInRefreshPassword = () => {

    const {state} = useLocation()
    const navigate = useNavigate()

    const service = new LoginService()
    const loading = new LoadingHelper(useLoadingDispatcher())


    const [submitCode, setSubmitCode] = useState("");
    const [phoneNumber, setPhoneNumber] = useState(state && state.phoneNumber ? state.phoneNumber : "");
    const [username, setUsername] = useState("");
    const [newPassword, setNewPassword] = useState("")

    function goForEditPhoneNumber() {
        navigate(RouteHelper.SignInForgetPassword.globalUrl, {state: {phoneNumber}, replace: true})
    }


    function validateAndRefreshPassword() {
        if (checkConditions()) {
            loading.show()

            service.updateForgotPassword(
                username,
                newPassword,
                phoneNumber,
                submitCode
            ).then(response => {
                showSuccessMessage("بروزرسانی با موفقیت انجام شد.")
                navigate(RouteHelper.SignInEnterPhoneNumber.globalUrl)
            }).catch(reason => {
                showErrorMessage(detectServerErrorMessage(reason))
            }).finally(_ => {
                loading.hide()
            })
        }
    }

    function checkConditions() {
        let message = ""
        let state = false
        if (username.length === 0) {
            message = "لطفا نام کاربری خود را به درستی وارد نمایید."
        } else if (newPassword.length < 8) {
            message = "رمز عبور حداقل باید شامل ۸ کاراکتر باشد."
        } else
            state = true

        showWarningMessage(message)

        return state
    }

    return (
        <>
            <Helmet>
                <title>{RouteHelper.SignInRefreshPassword.name}</title>
            </Helmet>

            <div className={"signInEnterPhoneContainer"}>
                <div className={"pageTitleContainer"}>
                    <img src={signInBanner} alt="ic signin"/>
                    <span className={"title"}>بازیابی رمز عبور</span>
                </div>
                <form className={"signInContentContainer"}>
                    <span className={"subTitle"}>لطفا کد تایید و اطلاعات خواسته شده را وارد نمایید.</span>
                    <div className={"editInfoContainer"}>
                        <div className={"editPhoneNumber"}
                             onClick={goForEditPhoneNumber}>
                            <div className={"ic-edit"}></div>
                            <span>{phoneNumber}</span>
                        </div>

                    </div>

                    <RaikoInputSubmitCode
                        handleCheckCode={validateAndRefreshPassword}
                        labelText={""}
                        value={submitCode}
                        getCodeValue={setSubmitCode}/>

                    <RaikoMaterialOutlinedInput
                        labelText={"نام کاربری"}
                        setValue={setUsername}
                        value={username}
                    />

                    <FormControl fullWidth>
                        <RaikoPasswordOutlined
                            doValidateData={validateAndRefreshPassword}
                            setValue={setNewPassword}
                            labelText="رمز عبور"
                            placeHolder="رمز عبور خود را وارد کنید"
                            spellCheck={false}
                            value={newPassword}
                        />
                    </FormControl>

                    <RaikoButtonPrimary
                        label={"تایید"}
                        className={css`width: 100%;
                          margin-top: .25rem !important;`}
                        onClick={validateAndRefreshPassword}/>

                </form>
            </div>
        </>
    )


}

export default SignInRefreshPassword;